import {t} from 'i18next'
import {Tooltip} from 'primereact/tooltip'
import React from 'react'
import {EducationRating} from '../../../../model/assessment.model'
import {Rating} from '../../../../model/enums/enums'
import {Observation} from '../../../../model/observation'

export const ratings: EducationRating[] = [
	{value: 1, key: 'A', rating: Rating.requirementsExceeded, label: t<string>('core.rating.requirements_exceeded')},
	{value: 2, key: 'B', rating: Rating.fulfilled, label: t<string>('core.rating.fulfilled')},
	{value: 3, key: 'C', rating: Rating.barelyFulfilled, label: t<string>('core.rating.barely_fulfilled')},
	{value: 4, key: 'D', rating: Rating.notFulfilled, label: t<string>('core.rating.not_fulfilled')}
]

export const RatingBody = (rowData: Observation): JSX.Element => {
	if (!rowData.rating) {
		return <></>
	}
	const rating = ratings.find(r => r.value === rowData.rating)
	const ratingKey = rating?.key

	return <span className={`p-badge text-center circle tag-${ratingKey}`}>
		{ratingKey}</span>
}

export const reasonBody = (rowData: Observation): JSX.Element => {
	if (!rowData.reason || !rowData?.observation_id) {
		return <></>
	}
	if (rowData.reason.length > 30) {
		const shortReason = rowData.reason.substring(0, 28) + '...'
		const cssClass = `shortReason_${rowData.observation_id}`
		return <>

			<div className={cssClass}>{shortReason}</div>
			<Tooltip
				appendTo={document.body}
				position={'top'}
				showDelay={500}
				style={{width: '200px'}}
				target={`.${cssClass}`} content={rowData.reason}/>
		</>
	}
	return <span>{rowData.reason}</span>

}